<template>
  <div class="agent-type-wrap">
    <div class="agent-type-container">
      <md-checkbox value="isMitaclub" :checked="isMitaclub" @change="change">
        {{ $t('find.MITACLUB') }}
      </md-checkbox>

      <md-checkbox value="isManager" :checked="isManager" @change="change">
        {{ $t('find.MANAGER') }}
      </md-checkbox>

      <md-checkbox value="isSales" :checked="isSales" @change="change"
        >{{ $t('find.SALES') }}
      </md-checkbox>
    </div>
  </div>
</template>
<script>
import MdCheckbox from '@/components/MaterialCheckbox';

export default {
  props: ['isMitaclub', 'isManager', 'isSales'],
  components: {
    MdCheckbox,
  },
  methods: {
    change(evt) {
      const checked = evt.target.checked;
      const filterKey = evt.target.value;
      this.$emit('updateFilter', { [filterKey]: checked ? '1' : null });
    },
  },
};
</script>
<style scoped>
.agent-type-wrap {
  background: #f8f8f8;
  padding: 16px 40px 15px;
  height: 232px;
}

.agent-type-wrap >>> .md-checkbox label:before {
  border-radius: 2px;
  border: 1px solid #9a9a9a;
  width: 18px;
  height: 18px;
}
.agent-type-wrap >>> .md-checkbox label {
  margin-bottom: 0;
  font-size: 16px;
  line-height: 17px;
  color: black;
}

.agent-type-wrap >>> .md-checkbox {
  margin: 16px 0;
}

/* laptop */
@media (min-width: 992px) and (max-width: 1199px) {
  .agent-type-container {
    max-width: 938px;
    margin: auto;
  }
}

/* mobile */
@media (max-width: 991px) {
  .agent-type-wrap {
    height: 100%;
  }
}
</style>
